import React from 'react';
import './rodape_internal.css';

export default function RodapeInternal() {
  return (
    <footer className="rodape-internal" aria-label="Rodapé">
      <div className="rodape-internal-strip">
        <p className="rodape-internal-copy">
          © {new Date().getFullYear()} Domínio Elétrico
        </p>
      </div>
    </footer>
  );
}
